<template>
    <div class="subsequent-cards col-12 col-lg-6 mb-4">
        <h3 class="mb-4 w-100 text-center color--blue-7">
            Buiten schooltijd
        </h3>
        <div
            v-if="activities.length > 1"
            ref="sliderOutside__controls"
            class="slider__controls"
            aria-label="Outside activities slider"
            tabindex="0"
        >
            <a
                class="prev"
                aria-controls="customize"
                data-controls="prev"
                tabindex="-1"
                ><i class="fa fa-chevron-left" aria-hidden="true"></i
            ></a>
            <a
                class="next"
                aria-controls="customize"
                data-controls="next"
                tabindex="-1"
                ><i class="fa fa-chevron-right" aria-hidden="true"></i
            ></a>
        </div>
        <div ref="sliderOutside" class="activities-outside__slider row">
            <activity-card
                v-for="activity in activities"
                :key="activity.id"
                class="mb-2 col-12 col-md-6"
                :activity="activity"
            ></activity-card>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import activityCard from '@/components/cards/activity-card';

export default {
    components: {
        activityCard
    },
    props: {
        activities: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            slider: ''
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$refs.sliderOutside,
                items: 1,
                controlsContainer: this.$refs.sliderOutside__controls,
                slideBy: 1,
                mouseDrag: false,
                swipeAngle: false,
                lazyload: false,
                nav: false,
                autoplayButton: false,
                autoplayButtonOutput: false,
                preventScrollOnTouch: 'auto',
                speed: 400,
                responsive: {
                    768: {
                        disable: true
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.activities-outside__slider {
    @include media-breakpoint-up(md) {
        margin: 0 -15px;
    }

    @include media-breakpoint-up(lg) {
        height: 100%;
    }
}

.slider__controls {
    position: absolute;
    height: 100%;
    width: 100%;
    display: block;
    left: 0;
}

.prev {
    position: absolute;
    left: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        left: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        left: -40px;
    }
}

.next {
    position: absolute;
    right: 15px;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        right: -20px;
        font-size: 30px;
    }

    @include media-breakpoint-up(lg) {
        right: -40px;
    }
}

.card {
    height: calc(100% - 1rem);
}
</style>
